import styled from "styled-components";

type StyledAssignCMModalProps = {
  $showFooter: boolean;
};

export const StyledAssignCMModal = styled.div<StyledAssignCMModalProps>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: ${({ $showFooter }) => ($showFooter ? "328px" : "400px")};

  & .cm-list-container {
    height: 270px;
  }
`;

export const StyledAvatarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  cursor: pointer;
  padding-bottom: 5px;
`;
